<template>
  <div>
    <img :src='_APIhost + "/CustomerData/" + userInfo.companyName + "/Forms/BannerImages/" + formElement.dynamicTypeData.value' />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "kollecto-image",
  props: ["formElement"],
  computed: {
    ...mapGetters({
      form: "getActiveForm",
      userInfo: "getUserData"
    })
  }
};
</script>
